<template>
  <div class="custom-tree-container">
    <div class="block">
      <el-row >
        <el-col id="col-tree"   >
          <el-container style="margin-bottom: 10px; ">
            <el-header>
              <el-input size="mini"
                v-model="search_folder_input"
                class="search_fields"
                :placeholder="model == 'any' ? 'search anything' : 'search quote id'"
                @keyup.enter.native="search_folders"
                style="width: 204px !important;"
                clearable
              />
              <el-button size="mini" type="primary" @click="search_folders()">Search</el-button>
              <el-input
                  v-model="filter_folders"
                  placeholder="filter folders"
                  class="search_fields"
                  size="mini"
                  clearable
                  style="width: 204px !important;"
              />
            </el-header>
            <el-main style="padding: 0px;background:#fff;">
              <el-tree
                ref="search_tree"
                :data="search_results"
                node-key="id"
                :default-expand-all="true"
                :expand-on-click-node="true"
                :filter-node-method="filter_node_search"
                highlight-current
                :lock-scroll="false"
                empty-text
                @node-click="get_files"
                v-loading="search_loading"
              >
                <span
                  slot-scope="{ node, data }"
                  class="custom-tree-node"
                >
                  <span>
                    {{ node.label | truncate(60, '...')  }}
                         <el-badge
                             v-show="data.count > 0"
                             :value="data.count"
                             class="item"
                         />
                  </span>
                  <span v-show="node.level > 1">
                    <el-button
                      type="text"
                      size="mini"
                      @click="append(node,data)"
                    >Create</el-button>
                    <el-button
                      type="text"
                      size="mini"
                      @click="edit_folder_name(node.label, data, node.id)"
                    >Edit</el-button>

                    <el-button
                      type="text"
                      size="mini"
                      @click="delete_folder(node, data)"
                    >Delete</el-button>
                  </span>
                </span>
              </el-tree>

              <el-tree
                  ref="tree"
                  :data="data"
                  node-key="id"
                  :expand-on-click-node="true"
                  :filter-node-method="filter_node"
                  highlight-current
                  :lock-scroll="false"
                  :load="load_nodes"
                  lazy
                  empty-text
                  @node-click="get_files"
                  style="max-height: 400px;"
              >
                <span
                    slot-scope="{ node, data }"
                    class="custom-tree-node"
                >
                  <span>
                    {{ node.label }}
                    <el-badge
                        v-show="data.count > 0"
                        :value="data.count"
                        class="item"
                    />
                  </span>
                  <span v-show="node.level > 1">
                    <el-button
                        type="text"
                        size="mini"
                        @click="append(node,data)"
                    >Create</el-button>
                    <el-button
                        type="text"
                        size="mini"
                        @click="edit_folder_name(node.label, data, node.id)"
                    >Edit</el-button>

                    <el-button
                        type="text"
                        size="mini"
                        @click="delete_folder(node, data)"
                    >Delete</el-button>
                  </span>
                </span>
              </el-tree>
            </el-main>
          </el-container>
        </el-col>

        <el-col id="col-files"  >
          <el-row>
          <el-input
            v-model="search_field"
            placeholder="search files"
            class="search_fields"
            @keyup.enter.native="search_files"
            size="mini"
            clearable
            style="width:200px !important;"
          />
          <el-button size="mini" type="primary" @click="search_files()">Search</el-button>
          <el-input
            v-model="filter_file_input"
            class="search_fields"
            placeholder="filter results"
            @keyup.native="filter_files"
            size="mini"
            clearable
            style="width:200px !important;"
          />

          <el-upload
            ref="upload"
            v-loading="loading"
            multiple
            class="upload"
            action="/upload_file_to_storage"
            :data="upload_data = {current_path: current_path}"
            :headers="{ 'X-CSRF-TOKEN': csfr}"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :on-success="success_upload"
            :on-error="error_upload"
            :on-progress="handleProgress"
            :file-list="up_files"
            list-type="picture"
            style="display: inline;"
          >
            <el-button
              size="mini"
              type="primary"
            >
              Click to upload
            </el-button>
          </el-upload>
          </el-row>
          <span>
            <hr>
            <div style="display: flex; justify-content: space-between; align-items: center;">
              <span>{{ current_path }}</span>
               <div>
                <el-tooltip content="assign user for file upload notification" placement="top">
                 <el-button @click="show_crmuser_dialog = true, get_crm_users()" size="mini" icon="el-icon-star-off" type="info" circle></el-button>
                </el-tooltip>
               <el-tooltip content="Send email to client" placement="top">
                 <el-button @click="send_notification_dialog = true, copy_client_link()" size="mini" type="primary" icon="el-icon-message" circle></el-button>
               </el-tooltip>
                 <el-button size="mini" type="success" @click="copy_client_link">Copy Client Link</el-button>
            </div>
            </div>
            <hr>
          </span>

          <transition name="el-fade-in">
            <el-button
              v-show="showMultiDeleteButton"
              type="danger"
              size="small"
              icon="el-icon-delete"
              @click="deleteRows"
            >
              Delete selected
            </el-button>
          </transition>

          <transition name="el-fade-in">
            <el-button
                v-show="showMultiDeleteButton"
                type="primary"
                size="small"
                icon="el-icon-edit"
                @click="send_files"
            >
              Send selected
            </el-button>
          </transition>

          <el-table
            ref="filesTable"
            :data="files"
            stripe
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              type="index"
              label="#"
              sortable
              width="50"
            />
            <el-table-column
              type="selection"
              width="55"
            />
            <el-table-column
                prop="url"
                label="Thumbnail"
                width="100"
            >
              <template v-slot="scope">
                <el-tooltip
                    placement="bottom"
                    effect="light"
                    :append-to-body="true"
                    trigger="hover"
                >
                  <template #content>
                    <img :src="scope.row.url_preview" >
                  </template>
                  <img
                      :src="scope.row.url"
                      width="70"
                      class="image"
                      style="cursor: zoom-in"
                  >
                </el-tooltip>
              </template>
            </el-table-column>

            <el-table-column
              prop="name"
              label="Name"
              sortable
              :sort-method="sortByName"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="mini"
                  @click="handlePreview(scope.row.url)"
                >
                  {{ scope.row.name }}
                </el-button>
              </template>
            </el-table-column>

            <el-table-column
              prop="size"
              label="Size"
              sortable
              :sort-method="sortBySize"
            />

            <el-table-column
              label="Date"
              sortable
              :sort-method="sortByDate"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.date }}</span>
              </template>
            </el-table-column>
            <el-table-column>
              <template slot-scope="scope">
                <el-tooltip content="Click to let the client view this file in their folder" placement="top">
                  <i
                      :class="scope.row.permission_enabled ? 'el-icon-camera-solid' : 'el-icon-camera'"
                      style="cursor: pointer; font-size: 22px; line-height: 1;"
                      @click="
        scope.row.permission_enabled = !scope.row.permission_enabled;
        set_file_permissions(scope.row.name, scope.row.permission_enabled);
      "
                  ></i>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label>
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="success"
                  icon="el-icon-edit"
                  circle
                  @click="edit_file_name(scope.row.name,scope.$index)"
                />
                <el-button
                  size="mini"
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  @click="deleteRow(scope.$index,scope.row.path)"
                />
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
    <el-dialog
        title="Send notification email"
        :visible.sync="send_notification_dialog"
        width="500px"
        :append-to-body="true"
        @opened="set_default_input"
    >
      <file-upload :current_path="current_path" @file-list="file_list_for_mail"  :file_list="file_list_mail"  ></file-upload>
      <el-form
          ref="form"
          :model="form"
          label-width="120px"
          class="transfer-form"
      >
        <el-form-item
            label="Path"
            prop="path"
            v-if="file_list_mail.length == 0"
        >
          <el-input v-model="form.path" />
        </el-form-item>
        <el-form-item
            label="Email to"
            prop="email_to"
        >
          <el-input v-model="form.email_to" />
        </el-form-item>

        <el-form-item
            label="Your Email"
            prop="your_email"
        >
          <el-input v-model="form.email_from" />
        </el-form-item>

        <el-form-item
            label="Title"
            prop="title"
        >
          <el-input v-model="form.title" />
        </el-form-item>

        <el-form-item
            label="Message"
            prop="message"
        >
          <el-input
              v-model="form.message"
              type="textarea"
              :rows="8"
          />
        </el-form-item>

        <el-form-item>
          <el-button
              type="primary"
              size="mini"
              @click="send_email"
          >
            Send
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
        title="Crm users file upload notification"
        :visible.sync="show_crmuser_dialog"
        width="500px"
        :append-to-body="true"
        @opened="set_default_input"
    >
      <p> Folder: {{ this.current_path }} </p>
      <el-checkbox-group v-model="checked_crmusers">
      <el-row :gutter="20">
        <el-col :span="10" v-for="user in crm_users" :key="user.id"  >
          <el-checkbox
              :label="user.id"
              @change="save_crmuser_for_notification_on_upload(user.id, $event)"
          >
            {{ user.user_name }} {{ user.user_surname }}
          </el-checkbox>
        </el-col>
      </el-row>
      </el-checkbox-group>
    </el-dialog>
  </div>
</template>
<script>
let id = 1000;
import Vue from 'vue';
import FileUpload from '../file_transfer/FileUpload.vue'

export default {
  name: 'Filebrowser',
  props: ['model', 'record_id'],
  components: {FileUpload},
  data() {
    const data = [];
    const search_results = [];
    return {
      data: JSON.parse(JSON.stringify(data)),
      search_results: JSON.parse(JSON.stringify(search_results)),
      filter_folders: '',
      search_folder_input: '',
      filter_file_input: null,
      files: [],
      up_files: [],
      showMultiDeleteButton: false,
      multipleSelection: [],
      new_node: false,
      current_path: '',
      current_id: '',
      in_context: true,
      csfr: Vue.http.headers.common['X-CSRF-Token'],
      loading: false,
      search_field: '',
      search_loading: false,
      send_notification_dialog: false,
      show_crmuser_dialog: false,
      form: {
        email_from: '',
        email_to: '',
        title: 'Notify client',
        message: '',
        path: ''},
      client_path: '',
      loadingInstance: null,
      crm_users: [],
      checked_crmusers: [],
      file_list_mail: []
    };
  },
  watch: {
    filter_folders(val) {
      this.$refs.tree.filter(val);
      this.$refs.search_tree.filter(val);
    },
    model(){
      this.search_folders();
    },
    current_path(){
      this.checked_crmusers = [];
      this.get_checked_crmusers_for_notification_on_upload();
    },
  },
  mounted(){
    this.set_default_input()
  },
  created() {
    this.search_folder_input = this.record_id;
    this.search_folders();
  },
  methods: {
    file_list_for_mail(file_list){
      this.file_list_mail = file_list;
    },
    get_checked_crmusers_for_notification_on_upload(){
      this.$http.get(`/get_checked_crmusers_for_notification_on_upload?path=${this.current_path}`).then((response) => {
        this.checked_crmusers = response.data.ids.map(id => Number(id));
      });
    },
    save_crmuser_for_notification_on_upload(id, checked){
      if(checked) {
        this.$http.post('/save_crmuser_for_notification_on_upload', {crm_user_id: id, path: this.current_path}).then(() => {
          this.$message({
            message: 'User saved.',
            type: 'success'
          });
        });
      } else {
        this.$http.post('/remove_crmuser_for_notification_on_upload', {crm_user_id: id, path: this.current_path}).then(() => {
          this.$message({
            message: 'User removed.',
            type: 'success'
          });
        });
      }
    },
    get_crm_users(){
        this.$http.get('/users_active_list').then((response) => {
          this.crm_users = response.data;
        });
    },
    send_email(){
      if (!this.form.path || this.form.path.trim() === "") {
        const url = 'https://' + window.location.host + "/api/file_transfers/download?file=";
        this.form.select_path = url + this.current_path +'/';
      }
      this.$http.post('/api/file_transfers/send_email_to_client', { form: this.form, file_list: this.file_list_mail }).then(response => {
        this.$message({
          message: response.data.message,
          type: 'success'
        });
      }).catch(() => {
        this.$message({
          message: 'Failed to send email.',
          type: 'error'
        });
      });
    },
    copy_client_link(){
      const url = 'https://' + window.location.host + '/client/login#/files?';
      let result;
      if (this.current_path.includes("Jobs")) {
        const index = this.current_path.indexOf("Jobs");
        result = this.current_path.substring(index);

        this.$http.post('/get_email_for_job', {
              params: { path: this.current_path + '/' }
            })
            .then(response => {
              this.form.email_from = response.data.email_from;
              this.form.email_to = response.data.email_to;
            });
      } else {
        result = "Jobs";
      }
       this.client_path = url + result;
      this.form.path = this.client_path;
      console.log(this.client_path);
      navigator.clipboard.writeText(this.client_path);
    },
    load_nodes(node, resolve) {
      this.set_current_path(node);

      this.$http
          .get('/browse_dir', {
            params: { path: this.current_path + '/' }
          })
          .then(response => {
            resolve(response.data.dirs);
          });
    },
    set_file_permissions(filename, permission_enabled){
      this.$http.post('/set_file_permission', {
            path: this.current_path + '/' + filename,
            permission_enabled: permission_enabled
          })
          .then(
              response => {
                this.files[index].name = value;
                this.$message({
                  type: 'success',
                  message: 'Client can access this file.'
                });
              }
          );
    },
    edit_file_name(filename, index) {
      this.$prompt('Please edit file name', 'EDIT', {
        confirmButtonText: 'Save',
        cancelButtonText: 'Cancel',
        inputPattern: /^[\w,\s-]+\.[\w,\s-]/,
        inputErrorMessage: 'Invalid file name',
        inputValue: filename
      })
        .then(({ value }) => {
          this.$http
            .post('/rename_file', {
              new_filename: this.current_path + '/' + value,
              filename: this.current_path + '/' + filename
            })
            .then(
              response => {
                this.files[index].name = value;
                this.$message({
                  type: 'success',
                  message: 'Your new file name is ' + value
                });
              },
              response => {
                this.$message({
                  message: 'Sorry, couldn\'t rename file ' + filename,
                  type: 'error'
                });
              }
            );
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Edit canceled'
          });
        });
    },
    edit_folder_name(foldername, data, id) {
      this.$prompt('Please edit folder name', 'EDIT', {
        confirmButtonText: 'Save',
        cancelButtonText: 'Cancel',
        inputPattern: /[\w,\s-]/,
        inputErrorMessage: 'Invalid folder name',
        inputValue: foldername
      })
        .then(({ value }) => {
          let new_foldername = value;
          let current_path = this.current_path;
          let new_name_path = '';
          current_path = current_path.substr(0, current_path.lastIndexOf('/'));
          if (current_path.length == 0) new_name_path = '/' + new_foldername;
          else new_name_path = current_path + '/' + new_foldername;

          this.$http
            .post('/rename_folder', {
              path: this.current_path,
              rename_dir_folder: new_name_path
            })
            .then(
              response => {
                this.current_path = new_name_path;
                data.label = new_foldername;
                this.$message({
                  message: 'Folder renamed to ' + new_foldername,
                  type: 'success'
                });
              },
              response => {
                this.$message({
                  message: 'couldn\'t rename folder ' + foldername,
                  type: 'error'
                });
              }
            );
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Edit canceled'
          });
        });
    },
    handleSelectionChange(selection) {
      if (selection.length >= 1) {
        this.showMultiDeleteButton = true;
      } else {
        this.showMultiDeleteButton = false;
      }
      this.multipleSelection = selection;
    },
    deleteRow(index, path) {
      this.$delete(this.files, index);
      this.delete_file(path);
    },
    deleteRows() {
      this.multipleSelection.forEach(file => {
        this.files.splice(file['path'], 1);
        this.delete_file(file['path']);
      });
    },
    send_files() {
      this.file_list_mail = this.multipleSelection;
      this.send_notification_dialog = true;
    },
    delete_file(path) {
      this.$http
        .get('/delete_file', {
          params: { path: path }
        })
        .then(response => {
          this.$message({
            message: 'File deleted!',
            type: 'success'
          });
        });
    },
    get_parent(node, arr) {
      if (node == undefined || node == null) return;

      arr.unshift(node.label);
      this.get_parent(node.parent, arr);
    },
    set_current_path(node) {
      const labels = [];
      this.get_parent(node, labels);
      this.current_path = labels.filter(item => item !== undefined).join('/');
    },
    get_files(data, node) {
      if (data != 'upload_files') this.set_current_path(node);
        this.current_id = data.id;
        this.loading = true;
        this.$http
          .get('/get_files_for_folder', {
            params: { path: this.current_path }
          })
          .then(response => {
            this.files = response.data.files;
            this.loading = false;
          });
    },
    search_files() {
      if (this.search_field.length > 1) {
        this.loading = true;
        this.$http
          .post('/search_files', {
            name: this.search_field
          })
          .then(response => {
            this.files = response.data.files;
            this.loading = false;
          }, reject => {
            this.$message({
              message: 'No file found',
              type: 'error'
            });
            this.loading = false;
          });
      }
    },
    search_folders() {
      if ((this.search_folder_input != undefined && this.search_folder_input.length > 2) ) {
        this.search_loading = true;
        this.$http
          .post('/search_folders', {
            name: this.search_folder_input,
            mode: this.model
          })
          .then(response => {
            this.search_loading = false;
            this.search_results = response.data.dirs;
            if(response.data.dirs.length == 0){
              this.$message({
                message: 'No folder with files found.',
                type: 'error'
              });
            }
          }, reject => {
            this.$message({
              message: 'No folder with files found',
              type: 'error'
            });
            this.search_loading = false;
          });
      } else {
        this.search_results = [];
        if (this.model == 'any'){
          // this.load_nodes();
        }
      }
    },
    filter_node_search(value, search_results) {
      if (!value) return true;
      if (search_results.label == null) return true;
      if (
        search_results.label.toLowerCase().indexOf(value.toLowerCase()) !== -1
      ) {
        return true;
      }
    },
    filter_node(value, data) {
      if (!value) return true;
      if (data.label == null) return true;
      if (data.label.toLowerCase().indexOf(value.toLowerCase()) !== -1) {
        return true;
      }
    },
    handleCheckChange(data, checked, indeterminate) {
      //console.log(data, checked, indeterminate);
    },
    handleNodeClick(data) {
      //console.log("node clicked");
    },

    append(node, data) {
      this.set_current_path(node);
      const newChild = { id: id++, label: 'new_folder' + id, children: [] };
      if (!data.children) {
        this.$set(data, 'children', []);
      }
      data.children.push(newChild);

      this.$http
        .get('/new_folder', {
          params: { path: this.current_path + '/' + newChild.label }
        })
        .then(response => {
          this.$message({
            message: 'Folder created ' + this.current_path,
            type: 'success'
          });
        });
    },
    delete_folder(node, data) {
      this.set_current_path(node);
      let folder = this.current_path.split('/');

      this.$confirm(
        'This will permanently delete the folder ' +
          folder.pop() +
          ', subfolders and files inside. Continue?',
        'Warning',
        {
          confirmButtonText: 'OK, DELETE',
          cancelButtonText: 'CANCEL',
          type: 'warning'
        }
      )
        .then(() => {
          this.$http
            .get('/delete_folder', {
              params: { path: this.current_path }
            })
            .then(
              response => {
                this.up_files = [];
                this.$refs.upload.clearFiles();
                node.parent.childNodes.splice(
                  node.parent.childNodes.findIndex(d => d.id == node.id),
                  1
                );
                this.$message({
                  message: 'Folder deleted',
                  type: 'success'
                });
              },
              response => {
                this.$message({
                  message: 'Folder not deleted',
                  type: 'error'
                });
              }
            );
        })
        .catch(() => {
          this.$message({
            type: 'success',
            message: 'Delete canceled'
          });
        });
    },
    filter_files() {
      const rows = this.$refs.filesTable.$refs.bodyWrapper.getElementsByClassName(
        'el-table__row'
      );
      for (let row of rows) {
        let cells = row.getElementsByTagName('td');
        for (let cell of cells) {
          let innerText = cell.innerText.toLowerCase();
          let filter_file_input = this.filter_file_input.toLowerCase();
          if (innerText.indexOf(filter_file_input) > -1) {
            row.style.display = '';
            break;
          } else {
            row.style.display = 'none';
          }
        }
      }
    },
    success_upload() {
      this.up_files = [];
      this.get_files('upload_files');
      this.$emit('file_uploaded', true);
      if (this.loadingInstance) {
        this.loadingInstance.close();
        this.loadingInstance = null;
      }
      this.$message.success('Upload successful!');
    },
    error_upload(err, file, fileList) {
      let msg = JSON.parse(err.message);
      if (this.loadingInstance) {
        this.loadingInstance.close();
        this.loadingInstance = null;
      }
      this.$message({
        message: msg.notice,
        type: 'error'
      });
    },
    handleRemove(file, fileList) {
      //console.log(file, fileList);
    },
    handlePreview(file) {
      let preview_url = String(file).replace('get_file', 'preview_file');
      let d = encodeURIComponent('&');
      let h = encodeURIComponent('#');
      preview_url  = String(preview_url).replace(/&/g, d).replace(/#/g, h);
      window.location = encodeURI(preview_url);
    },
    handleProgress(event) {
      if (!this.loadingInstance) {
        this.loadingInstance = this.$loading({
          lock: true,
          text: `Uploading... ${Math.round(event.percent)}%`,
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.8)'
        });
      } else {
        this.loadingInstance.setText(`Uploading... ${Math.round(event.percent)}%`);
      }
    },
    sortByName(a, b) {
      return a.name.localeCompare(b.name);
    },
    sortBySize(a, b) {
      const sizeA = this.parseSizeToBytes(a.size);
      const sizeB = this.parseSizeToBytes(b.size);
      return sizeA - sizeB;
    },
    sortByDate(a, b) {
      const dateA = this.parseDate(a.date);
      const dateB = this.parseDate(b.date);
      return dateA - dateB;
    },
    parseSizeToBytes(size) {
      if (!size) return 0;
      const units = {
        KB: 1024,
        MB: 1024 * 1024,
        GB: 1024 * 1024 * 1024
      };
      const match = size.match(/([\d.]+)\s?(KB|MB|GB)/i);
      if (!match) return parseFloat(size) || 0;
      const value = parseFloat(match[1]);
      const unit = match[2].toUpperCase();
      return value * (units[unit] || 1);
    },
    parseDate(dateString) {
      const [day, month, year] = dateString.split(".");
      return new Date(`${year}-${month}-${day}`);
    },
    set_default_input() {
      Array.from(document.querySelectorAll('.el-input__inner')).forEach(
          function (e) {
            e.classList.add('browser-default');
            if (e.querySelector('input') != null)
              e.querySelector('input').className += ' browser-default';
          }
      );
    },
  }
};
</script>

<style scoped>
.custom-tree-container .el-tree {
  max-height: none;
}
.custom-tree-node {
  /*flex: 1;*/
  /*display: flex;*/
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.custom-tree-container > .el-input__inner {
  height: 20px !important;
  line-height: 20px !important;
  padding-top: 12px !important;
  font-weight: normal !important;
  color: #4c4c4cde !important;
}

.el-input__inner::-webkit-input-placeholder {
  color: orange !important;
  font-weight: normal !important;
  font-size: 12px;
  opacity: 0.8;
  font-family: "Roboto", sans-serif !important;
}
.el-table th > .cell {
  font-size: 14px;
  font-weight: normal;
  color: #606266;
}
.el-table .cell a {
  color: #409eff;
  font-size: 12px;
}

.el-table .cell {
  font-size: 12px;
}
.custom-tree-container /deep/ .el-tree__empty-block {
  min-height: 0px !important;
  margin-bottom: 10px;
}

.custom-tree-container /deep/ .el-header{
  height: auto !important;
}

.custom-tree-node .el-badge {
  padding-top: 8px;
}

.el-tree {
  width: 100%;
  overflow-x: scroll;
}

.el-tree > .el-tree-node {
  min-width: 100%;
  display: inline-block !important;
}

.search_fields {
  width: 49% !important;
}

.custom-tree-container /deep/ .el-table .cell {
  padding-right: 0px !important;
}
.custom-tree-container /deep/ td {
  display: table-cell !important;
}
#col-files{
  padding-left: 15px;
}


@media only screen and (min-width: 993px) {
 #col-tree{ width: 40%;}
  #col-files{ width: 58%;}
}
</style>
